import { ChangeDetectorRef, Component } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { charts as chartsCatalog } from 'src/app/utils/catalog';
import { BaseFormComponent } from '../base-form/base-form.component';

@Component({
  selector: 'app-chart-settings-form',
  templateUrl: './chart-settings-form.component.html',
  styleUrls: ['./chart-settings-form.component.scss'],
})
export class ChartSettingsFormComponent extends BaseFormComponent {
  public types = Object.values(chartsCatalog.types);
  public scales = Object.values(chartsCatalog.scales);

  constructor(translator: TranslateService, changeDetection: ChangeDetectorRef, formBuilder: UntypedFormBuilder) {
    super(
      translator,
      changeDetection,
      formBuilder.group({
        type: [chartsCatalog.types.verticalBar, Validators.required],
        // scales: [[chartsCatalog.scales.day], Validators.required],
      })
    );
  }
}
